<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<ng-container *ngIf="rideOpsUi.isV2Active$ | async; else v1Picker">
	<div class="user-picker-v2">
		<header class="user-picker-v2-header">
			<h2 class="user-picker-v2-title">{{ "OPERATORS_V2__CHOOSE_AN_ACCOUNT" | transloco }}</h2>
			<button
				type="button"
				class="user-picker-v2-close"
				(click)="dismiss()"
				[attr.aria-label]="'OPERATORS_V2__CANCEL' | transloco"
			>
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">close</span>
			</button>
		</header>

		<button
			*ngIf="barcodeSignIn$ | async"
			type="button"
			class="user-picker-v2-scan"
			(click)="scanBadge()"
		>
			<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
				qr_code_scanner
			</span>
			<span>{{ "OPERATORS_V2__SCAN_YOUR_BADGE" | transloco }}</span>
		</button>

		<div class="user-picker-v2-divider" *ngIf="barcodeSignIn$ | async">
			<span>{{ "OPERATORS_V2__OR_CHOOSE_FROM_LIST" | transloco }}</span>
		</div>

		<div class="user-picker-v2-search">
			<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">search</span>
			<input
				type="text"
				[formControl]="userSearch"
				[placeholder]="'OPERATORS_V2__TYPE_NAME_TO_SEARCH' | transloco"
			/>
			<button
				*ngIf="userSearch.value"
				type="button"
				class="user-picker-v2-search-clear"
				(click)="clearSearch()"
				[attr.aria-label]="'OPERATOR_LOGIN__CLEAR' | transloco"
			>
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">close</span>
			</button>
		</div>

		<ng-container *ngLet="{ currentOperatorId: currentOperatorId, operators: operators$ | async } as model">
			<div class="user-picker-v2-list" *ngIf="model.operators?.length > 0">
				<button
					type="button"
					class="user-picker-v2-row"
					*ngFor="let operator of model.operators; trackBy: trackByOperatorId"
					(click)="select(operator)"
					[class.user-picker-v2-row--disabled]="operator.missingCompetencies?.length > 0"
					[class.user-picker-v2-row--current]="model.currentOperatorId === operator.id"
				>
					<app-avatar
						[file]="operator.profileImage"
						[name]="operator.name"
						[userId]="operator.id"
						[size]="44"
					></app-avatar>
					<div class="user-picker-v2-row-text">
						<div class="user-picker-v2-row-primary">{{ operator.name }}</div>
						<div class="user-picker-v2-row-secondary">
							{{
								model.currentOperatorId === operator.id
									? ("OPERATORS_PAGE__LOGOUT" | transloco)
									: ("OPERATORS_PAGE__OPERATOR" | transloco)
							}}
						</div>
					</div>
					<span
						class="material-symbols-outlined material-symbols-outlined--size-24 user-picker-v2-row-action"
						aria-hidden="true"
					>
						{{ model.currentOperatorId === operator.id ? "logout" : "login" }}
					</span>
				</button>
			</div>

			<div class="user-picker-v2-empty" *ngIf="model.operators?.length === 0">
				<span>{{ "OPERATORS_PAGE__NO_OPERATORS_WHEN_SEARCHING_FOR" | transloco }}</span>
				<span>&nbsp;{{ userSearch.value }}</span>
			</div>
		</ng-container>
	</div>
</ng-container>

<ng-template #v1Picker>
	<div class="modal-container">
		<h1>{{ label }}</h1>

		<ng-container *ngLet="{ currentOperatorId: currentOperatorId, operators: operators$ | async } as model">
			<div class="users-container">
				<ion-card
					*ngFor="let operator of model.operators; trackBy: trackByOperatorId"
					class="operator"
					(click)="select(operator)"
					[ngClass]="{ disabled: operator.missingCompetencies?.length > 0 }"
				>
					<ion-card-header>
						<ion-button *ngIf="model.currentOperatorId === operator.id" shape="round" class="logout">
							{{ "OPERATORS_PAGE__LOGOUT" | transloco }}
						</ion-button>
						<app-avatar
							*ngIf="model.currentOperatorId !== operator.id"
							[file]="operator.profileImage"
							[name]="operator.name"
							[userId]="operator.id"
						></app-avatar>
					</ion-card-header>

					<ion-card-title>{{ operator.name }}</ion-card-title>
				</ion-card>
			</div>

			<div class="no-searchresults" *ngIf="model.operators.length === 0">
				<span class="title">{{ "OPERATORS_PAGE__NO_OPERATORS_WHEN_SEARCHING_FOR" | transloco }}</span>
				<span class="subtitle">&nbsp;{{ userSearch.value }}</span>
			</div>

			<ion-item>
				<ion-input
					type="text"
					placeholder="{{ 'OPERATORS_PAGE__SEARCH' | transloco }}"
					clear-input="true"
					[formControl]="userSearch"
				>
					<div slot="label"><ion-icon name="search"></ion-icon></div>
				</ion-input>
			</ion-item>
		</ng-container>
	</div>
</ng-template>
